exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#app{font-family:Helvetica,Arial,sans-serif,verdana,tahoma,Avenir;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;padding-top:constant(safe-area-inset-top);padding-top:env(safe-area-inset-top);padding-bottom:constant(safe-area-inset-bottom);padding-bottom:env(safe-area-inset-bottom)}#app,.listStyle{background-color:#eee}.listStyle{padding-top:1px}.skuCardStyle{background-color:#fff;padding:5px;border-radius:6px}", ""]);

// exports
